import React from 'react';
import {Button, Col, Label, Row} from 'reactstrap';
import {AvForm, AvGroup} from 'availity-reactstrap-validation';
import {Fieldset} from 'primereact/fieldset';
import Translate from '../../shared/language/Translate';
import GeneralUtils from '../../shared/utils/GeneralUtils';
import AvField from '../../shared/component/form/AvField';
import PurchaseRequisitionService from '../../shared/service/PurchaseRequisitionService';
import LicenseService from '../../shared/service/LicenseService';
import PurchaseRequisitionItemMobileListColumn from '../../shared/component/dataTable/columns/PurchaseRequisitionItemMobileListColumn.json';
import Dialog from '../../shared/component/dialog/Dialog';
import Loading from '../../shared/component/others/Loading';
import PurchaseRequisitionItemMobileSave from './PurchaseRequisitionItemMobileSave';
import PurchaseRequisitionItemDataTable from '../purchaserequisition/PurchaseRequisitionItemDataTable';
import SupplierFilter from '../storemanagement/SupplierFilter';
import {applyCostWarningsToItems, getRequisitionDocLabels, isDuplicateBarcodeInList, isReturnItemsLockedFromDeliveryNote, normalizeItem, normalizeRequisition, persistRequisitionToDb, removeItemFromList, upsertRequisitionItem} from '../purchaserequisition/PurchaseRequisitionUtils';
import {getPurchaseRequisitionMobileListReturnHash} from '../purchaserequisition/PurchaseRequisitionListNav';
import dayjs from 'dayjs';
import {toast} from 'react-toastify';
import '../../shared/styles/SettingsPage.css';

const LICENSE_REQUIRED_MESSAGE = "You don't have an invoice license.";

const defaultRequisition = {
    id: null,
    description: '',
    requisitionStatus: 'OPEN',
    createDate: null,
    supplierId: null,
    supplierName: null,
    supplierBssId: null,
    itemList: []
};

const defaultItem = {
    id: null,
    barcode: null,
    itemName: null,
    itemBssId: null,
    itemUnitMeasure: null,
    itemSize: null,
    boxSize: null,
    deliveredBoxCount: null,
    orderUnitOfMeasure: 'SINGLE',
    supplierId: null,
    supplierName: null,
    supplierBssId: null,
    currentCost: null,
    minStock: null,
    maxStock: null,
    recommendedOrderAmount: null,
    actualOrderAmount: null,
    damagedQuantity: null,
    expiryDate: null,
    currentStock: null,
    status: 'ACTIVE'
};

export default class PurchaseRequisitionSaveMobile extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            hasInvoiceLicense: false,
            requisition: Object.assign({}, defaultRequisition),
            loading: false,
            displayDialog: false,
            displaySupplierFilterDialog: false
        };
        this.purchaseRequisitionService = new PurchaseRequisitionService();
        this.licenseService = new LicenseService();
        this.dialogHistoryPushed = false;
        this.ignoreNextPopState = false;
        this.handlePopState = this.handlePopState.bind(this);
        this.handleBackButton = this.handleBackButton.bind(this);
    }

    componentDidMount() {
        if (!GeneralUtils.isMobile()) {
            window.location.href = '#';
            return;
        }
        this.licenseService.getLicenses(localStorage.getItem('merchantBranchId')).then(response => {
            if (!GeneralUtils.isNullOrEmpty(response) && GeneralUtils.isNullOrEmpty(response.type)
                && response.hasInvoiceLicense === true) {
                this.setState({hasInvoiceLicense: true}, () => {
                    window.history.pushState(null, document.title, window.location.href);
                    window.addEventListener('popstate', this.handlePopState);
                    window.__purchaseRequisitionMobileBack = this.handleBackButton;

                    const id = this.getRequisitionIdFromUrl();
                    if (!GeneralUtils.__isValueEmpty(id) && id !== '-1') {
                        this.loadRequisition(id);
                    } else {
                        this.initNewRequisition();
                    }
                });
            } else {
                toast.warn(LICENSE_REQUIRED_MESSAGE);
                window.location.href = getPurchaseRequisitionMobileListReturnHash();
            }
        });
    }

    getRequisitionIdFromUrl = () => {
        const query = window.location.href.split('?')[1];
        if (GeneralUtils.__isValueEmpty(query)) {
            return null;
        }
        const idPart = query.split('&')[0];
        if (!GeneralUtils.__isValueEmpty(idPart) && idPart !== '-1') {
            return idPart;
        }
        return null;
    };

    isDeliveryModeFromUrl = () => {
        const query = window.location.href.split('?')[1] || '';
        return query.includes('mode=delivery');
    };

    isReturnModeFromUrl = () => {
        const query = window.location.href.split('?')[1] || '';
        return query.includes('mode=returnNote') || query.includes('mode=return');
    };

    isDeliveryNote = () => this.state.requisition?.requisitionStatus === 'DELIVERY_NOTE';

    isReturnNote = () => this.state.requisition?.requisitionStatus === 'RETURN';

    isApproved = () => {
        const approved = this.state.requisition?.approved;
        return approved === true || approved === 'true' || approved === 1 || approved === '1';
    };

    isEditable = () => {
        if (this.isApproved()) {
            return false;
        }
        const status = this.state.requisition?.requisitionStatus;
        return status === 'OPEN' || status === 'DELIVERY_NOTE' || status === 'RETURN';
    };

    areReturnItemsLockedFromDn = () => isReturnItemsLockedFromDeliveryNote(this.state.requisition);

    areItemsEditable = () => this.isEditable() && !this.areReturnItemsLockedFromDn();

    componentWillUnmount() {
        window.removeEventListener('popstate', this.handlePopState);
        if (window.__purchaseRequisitionMobileBack === this.handleBackButton) {
            delete window.__purchaseRequisitionMobileBack;
        }
    }

    initNewRequisition = () => {
        let requisitionStatus = 'OPEN';
        if (this.isDeliveryModeFromUrl()) {
            requisitionStatus = 'DELIVERY_NOTE';
        } else if (this.isReturnModeFromUrl()) {
            requisitionStatus = 'RETURN';
        }
        this.setState({
            requisition: {
                ...defaultRequisition,
                requisitionStatus,
                createDate: dayjs().format('DD/MM/YYYY'),
                itemList: []
            }
        });
    };

    loadRequisition = (id) => {
        this.setState({loading: true});
        this.purchaseRequisitionService.findById(id).then(response => {
            if (!GeneralUtils.isNullOrEmpty(response) && GeneralUtils.isNullOrEmpty(response.type)) {
                const requisition = Object.assign({}, response);
                if (requisition.createDate) {
                    requisition.createDate = dayjs(requisition.createDate).format('DD/MM/YYYY');
                }
                if (requisition.checkoutDate) {
                    requisition.checkoutDate = dayjs(requisition.checkoutDate).format('DD/MM/YYYY');
                }
                requisition.itemList = (requisition.itemList || []).map(normalizeItem);
                this.applyCostWarnings(requisition).then(enriched => {
                    this.setState({requisition: enriched, loading: false});
                });
            } else {
                this.setState({loading: false});
            }
        }).catch(() => this.setState({loading: false}));
    };

    applyCostWarnings = (requisition) => {
        if (!requisition?.id || requisition.requisitionStatus !== 'OPEN') {
            return Promise.resolve(requisition);
        }
        return this.purchaseRequisitionService.getCostWarnings(requisition.id).then(warnings => {
            if (GeneralUtils.isNullOrEmpty(warnings) || !GeneralUtils.isNullOrEmpty(warnings.type)) {
                return requisition;
            }
            return {
                ...requisition,
                itemList: applyCostWarningsToItems(requisition.itemList, warnings)
            };
        }).catch(() => requisition);
    };

    hasSavedRequisition = () => !GeneralUtils.isNullOrEmpty(this.state.requisition?.id);

    getItemListFields = () => {
        const isDelivery = this.isDeliveryNote();
        const isReturn = this.isReturnNote();
        // Mobile: few columns — detail dialog has the rest. Barcode is detail-only.
        const mobileFields = isDelivery
            ? ['itemNameWithSizeAndQuantity', 'actualOrderAmount']
            : isReturn
                ? ['itemNameWithSizeAndQuantity', 'actualOrderAmount', 'reasonCode']
                : ['itemNameWithSizeAndQuantity', 'actualOrderAmount'];

        return PurchaseRequisitionItemMobileListColumn.fields
            .filter(field => mobileFields.includes(field.field))
            .map(field => {
                if (field.field === 'itemNameWithSizeAndQuantity') {
                    return {
                        ...field,
                        field: 'longName',
                        header: 'Name',
                        visible: true,
                        filter: true,
                        style: {
                            width: isReturn ? '48%' : '60%',
                            textAlign: 'left',
                            whiteSpace: 'normal',
                            wordBreak: 'break-word'
                        }
                    };
                }
                if (field.field === 'actualOrderAmount') {
                    let header = 'Total';
                    if (isDelivery) {
                        header = 'Total';
                    } else if (isReturn) {
                        header = 'Return Qty';
                    }
                    return {
                        ...field,
                        header,
                        visible: true,
                        customBody: 'actualOrderWithUnitBody',
                        style: {width: isReturn ? '28%' : '40%', textAlign: 'right'}
                    };
                }
                if (field.field === 'reasonCode') {
                    return {
                        ...field,
                        header: 'Reason',
                        visible: true,
                        style: {width: '24%', textAlign: 'center'}
                    };
                }
                return {...field, visible: true};
            });
    };

    getItemListRowClassName = (rowData) => {
        const damaged = Number(rowData?.damagedQuantity);
        if (!Number.isNaN(damaged) && damaged > 0) {
            return {highlightTableRowLightRed: true};
        }
        return {};
    };

    saveRequisition = () => {
        if (!this.isEditable()) {
            return;
        }
        const requisition = {...this.state.requisition};
        const itemList = Array.isArray(requisition.itemList) ? requisition.itemList : [];

        if (this.isDeliveryNote() && GeneralUtils.isNullOrEmpty(requisition.supplierId)) {
            toast.warn('Please select a supplier!');
            return;
        }

        const allowEmptyDraft = this.isDeliveryNote() || this.isReturnNote();
        if (itemList.length === 0 && !allowEmptyDraft) {
            toast.warn('Please add at least one item!');
            return;
        }

        this.setState({loading: true});
        persistRequisitionToDb(requisition, this.purchaseRequisitionService).then(result => {
            if (!result.success) {
                this.setState({loading: false});
                if (result.reason === 'empty') {
                    toast.warn('Please add at least one item!');
                }
                return;
            }
            const saved = result.requisition;
            const hadId = !GeneralUtils.isNullOrEmpty(requisition.id);
            this.setState({requisition: saved, loading: false}, () => {
                if (!hadId && saved.id) {
                    const modeSuffix = this.isDeliveryNote()
                        ? '&mode=delivery'
                        : (this.isReturnNote() ? '&mode=returnNote' : '');
                    window.history.replaceState(null, document.title, '#inventoryManagementSaveMobile?' + saved.id + modeSuffix);
                }
            });
        });
    };

    onDataSelect = (data) => {
        // Allow opening items when document is not editable — form is view-only (Close only).
        this.pushDialogHistory();
        GeneralUtils.openDialogThenRef(this, {displayDialog: true}, () => this.refModelSave, (ref) => ref.setData(data));
    };

    addNewItem = () => {
        if (!this.areItemsEditable()) {
            if (this.areReturnItemsLockedFromDn()) {
                toast.warn('Items from Delivery Note cannot be changed');
            }
            return;
        }
        if (this.isDeliveryNote() && GeneralUtils.isNullOrEmpty(this.state.requisition.supplierId)) {
            toast.warn('Please select a supplier first');
            this.openDeliverySupplierDialog();
            return;
        }
        const item = Object.assign({}, defaultItem);
        if (this.isDeliveryNote() || this.isReturnNote()) {
            item.boxSize = 1;
            item.deliveredBoxCount = 1;
        }
        if (this.isDeliveryNote()) {
            item.supplierId = this.state.requisition.supplierId ?? null;
            item.supplierName = this.state.requisition.supplierName ?? null;
            item.supplierBssId = this.state.requisition.supplierBssId ?? null;
            item.currentSupplierId = this.state.requisition.supplierId ?? null;
            item.currentSupplierName = this.state.requisition.supplierName ?? null;
        }
        if (!this.isDeliveryNote() && !this.isReturnNote()) {
            item.boxSize = 1;
            item.deliveredBoxCount = 1;
        }
        this.onDataSelect(item);
    };

    persistItemAndContinue = (itemData, closeAfterSave = true) => {
        if (!this.areItemsEditable()) {
            if (this.areReturnItemsLockedFromDn()) {
                toast.warn('Items from Delivery Note cannot be changed');
            }
            return;
        }
        if (this.isDeliveryNote() && GeneralUtils.isNullOrEmpty(this.state.requisition.supplierId)) {
            toast.warn('Please select a supplier first');
            this.openDeliverySupplierDialog();
            return;
        }
        if (isDuplicateBarcodeInList(this.state.requisition.itemList, itemData)) {
            toast.warn("Don't allow duplicate entries");
            return;
        }
        const {itemList} = upsertRequisitionItem(this.state.requisition.itemList, itemData);
        const requisition = {...this.state.requisition, itemList};
        const hadRequisitionId = !GeneralUtils.isNullOrEmpty(requisition.id);

        this.setState({loading: true});
        persistRequisitionToDb(requisition, this.purchaseRequisitionService).then(result => {
            if (!result.success) {
                this.setState({loading: false});
                return;
            }
            this.applyCostWarnings(result.requisition).then(enriched => {
                this.setState({requisition: enriched, loading: false}, () => {
                    if (!hadRequisitionId && enriched.id) {
                        const modeSuffix = this.isDeliveryNote()
                            ? '&mode=delivery'
                            : (this.isReturnNote() ? '&mode=returnNote' : '');
                        window.history.replaceState(null, document.title, '#inventoryManagementSaveMobile?' + enriched.id + modeSuffix);
                    }
                    if (closeAfterSave) {
                        this.closeItemDialog();
                        return;
                    }
                    const nextItem = Object.assign({}, defaultItem);
                    if (this.isDeliveryNote()) {
                        nextItem.deliveredBoxCount = 1;
                        nextItem.supplierId = this.state.requisition.supplierId ?? null;
                        nextItem.supplierName = this.state.requisition.supplierName ?? null;
                        nextItem.supplierBssId = this.state.requisition.supplierBssId ?? null;
                        nextItem.currentSupplierId = this.state.requisition.supplierId ?? null;
                        nextItem.currentSupplierName = this.state.requisition.supplierName ?? null;
                    }
                    GeneralUtils.openDialogThenRef(
                        this,
                        {displayDialog: true},
                        () => this.refModelSave,
                        (ref) => ref.setData(nextItem)
                    );
                });
            });
        });
    };

    saveItem = (itemData) => this.persistItemAndContinue(itemData, true);

    saveItemAndNext = (itemData) => this.persistItemAndContinue(itemData, false);

    deleteItem = (itemData) => {
        if (!this.areItemsEditable()) {
            if (this.areReturnItemsLockedFromDn()) {
                toast.warn('Items from Delivery Note cannot be changed');
            }
            return;
        }
        if (!itemData) {
            this.closeItemDialog();
            return;
        }

        // New line not yet in the list — just close the dialog.
        const list = this.state.requisition.itemList || [];
        const inList = list.some(item =>
            (itemData.id != null && item?.id === itemData.id)
            || (itemData.barcode && item?.barcode === itemData.barcode)
        );
        if (!inList) {
            this.closeItemDialog();
            return;
        }

        const itemList = removeItemFromList(list, itemData);
        const allowEmpty = this.isDeliveryNote() || this.isReturnNote();
        if (itemList.length === 0 && !allowEmpty) {
            toast.warn('Requisition must have at least one item!');
            return;
        }

        const requisition = {...this.state.requisition, itemList};
        if (!this.hasSavedRequisition()) {
            this.setState({requisition}, () => this.closeItemDialog());
            return;
        }

        this.setState({loading: true});
        persistRequisitionToDb(requisition, this.purchaseRequisitionService).then(result => {
            if (!result.success) {
                this.setState({loading: false});
                return;
            }
            this.applyCostWarnings(result.requisition).then(enriched => {
                this.setState({requisition: enriched, loading: false}, () => this.closeItemDialog());
            });
        });
    };

    closeItemDialog = () => {
        this.setState({displayDialog: false});
        this.popDialogHistory();
    };

    __handleChange = (e) => {
        if (!this.isEditable()) {
            return;
        }
        const value = e.target.parsedValue !== undefined ? e.target.parsedValue : e.target.value;
        this.setState(prev => ({
            requisition: {...prev.requisition, [e.target.name]: value}
        }));
    };

    applyDeliverySupplier = (supplier) => {
        if (!this.isEditable() || !this.isDeliveryNote()) {
            return;
        }
        const wasOpen = this.state.displaySupplierFilterDialog;
        this.setState(prev => ({
            displaySupplierFilterDialog: false,
            requisition: {
                ...prev.requisition,
                supplierId: supplier?.id != null ? Number(supplier.id) : null,
                supplierName: supplier?.name || null,
                supplierBssId: supplier?.bssId || null
            }
        }));
        if (wasOpen) {
            this.popDialogHistory();
        }
    };

    openDeliverySupplierDialog = () => {
        if (!this.isEditable() || !this.isDeliveryNote()) {
            return;
        }
        this.pushDialogHistory();
        this.setState({displaySupplierFilterDialog: true});
    };

    closeDeliverySupplierDialog = () => {
        this.setState({displaySupplierFilterDialog: false});
        this.popDialogHistory();
    };

    clearDeliverySupplier = () => {
        if (!this.isEditable() || !this.isDeliveryNote()) {
            return;
        }
        this.setState(prev => ({
            requisition: {
                ...prev.requisition,
                supplierId: null,
                supplierName: null,
                supplierBssId: null
            }
        }));
    };

    handleBackButton = () => {
        if (this.state.displaySupplierFilterDialog) {
            this.closeDeliverySupplierDialog();
            return true;
        }
        if (this.state.displayDialog) {
            this.closeItemDialog();
            return true;
        }
        return false;
    };

    renderButtons() {
        const editable = this.isEditable();
        return (
            <div className="mobile-fixed-footer">
                <div className="mobile-fixed-footer-inner">
                    {editable &&
                        <Button
                            color="outline-primary"
                            style={{marginRight: '5px', height: '30px', width: '110px'}}
                            onClick={this.saveRequisition}
                        >
                            <Translate contentKey="entity.action.add">Save</Translate>
                        </Button>
                    }
                    <Button
                        color="outline-primary"
                        className="settings-page__btn--cancel settings-page__btn--back"
                        style={{marginRight: '5px', height: '30px', minWidth: '110px'}}
                        onClick={() => { window.location.href = getPurchaseRequisitionMobileListReturnHash(); }}
                    >
                        <i className="pi pi-arrow-left" aria-hidden="true"/>
                        <Translate contentKey="entity.action.cancel">Back</Translate>
                    </Button>
                </div>
            </div>
        );
    }

    render() {
        if (!GeneralUtils.isMobile()) {
            return null;
        }
        if (!this.state.hasInvoiceLicense) {
            return null;
        }

        const items = this.state.requisition.itemList || [];
        const isDelivery = this.isDeliveryNote();
        const isReturn = this.isReturnNote();
        const isDeliveryOrReturn = isDelivery || isReturn;
        const {docTitle: detailLegend, docNoLabel: noLabel} = getRequisitionDocLabels(
            this.state.requisition?.requisitionStatus,
            {forDetailPage: true, forMobile: true}
        );

        return (
            <div className="mobile-page-content">
                <AvForm autocomplete="off" onSubmit={(e) => e.preventDefault()}>
                    <Fieldset legend={detailLegend}>
                        <Row>
                            <Col md="6">
                                <AvGroup>
                                    <Label for="requisitionNo">
                                        {noLabel}
                                    </Label>
                                    <AvField
                                        type="text"
                                        name="requisitionNo"
                                        disabled={true}
                                        value={this.state.requisition.requisitionNo || ''}
                                    />
                                </AvGroup>
                            </Col>
                            <Col md="6">
                                <AvGroup>
                                    <Label for="createDate">
                                        <Translate contentKey="merchantBranch.updateDate">Create Date</Translate>
                                    </Label>
                                    <AvField
                                        type="text"
                                        name="createDate"
                                        disabled={true}
                                        value={this.state.requisition.createDate || ''}
                                    />
                                </AvGroup>
                            </Col>
                        </Row>
                        {isDelivery &&
                            <Row>
                                <Col md="12">
                                    <AvGroup>
                                        <Label for="supplierName">
                                            Supplier
                                            <span style={{color: 'red'}}> *</span>
                                        </Label>
                                        <div style={{position: 'relative'}}>
                                            <input
                                                id="supplierName"
                                                type="text"
                                                name="supplierName"
                                                className="form-control"
                                                style={{paddingRight: this.isEditable() ? '52px' : undefined}}
                                                disabled
                                                readOnly
                                                value={this.state.requisition.supplierName || ''}
                                            />
                                            {this.isEditable() &&
                                                <div
                                                    style={{
                                                        position: 'absolute',
                                                        right: '6px',
                                                        top: '50%',
                                                        transform: 'translateY(-50%)',
                                                        display: 'flex',
                                                        gap: '6px',
                                                        alignItems: 'center'
                                                    }}
                                                >
                                                    {!GeneralUtils.isNullOrEmpty(this.state.requisition.supplierId) &&
                                                        <i
                                                            className="pi pi-times"
                                                            role="button"
                                                            tabIndex={0}
                                                            title="Clear supplier"
                                                            style={{cursor: 'pointer'}}
                                                            onClick={this.clearDeliverySupplier}
                                                        />
                                                    }
                                                    <i
                                                        className="pi pi-search"
                                                        role="button"
                                                        tabIndex={0}
                                                        title="Search supplier"
                                                        style={{cursor: 'pointer'}}
                                                        onClick={this.openDeliverySupplierDialog}
                                                    />
                                                </div>
                                            }
                                        </div>
                                    </AvGroup>
                                </Col>
                            </Row>
                        }
                        <Dialog
                            visible={this.state.displaySupplierFilterDialog}
                            header="Supplier"
                            onHide={this.closeDeliverySupplierDialog}
                            style={GeneralUtils.getDialogStyleForSupplierFilter()}
                        >
                            <SupplierFilter
                                onDataSelect={this.applyDeliverySupplier}
                                closeDisplayDialog={this.closeDeliverySupplierDialog}
                            />
                        </Dialog>
                        <Row>
                            {!isDeliveryOrReturn &&
                                <Col md="6">
                                    <AvGroup>
                                        <Label for="checkoutDate">Checkout Date</Label>
                                        <AvField
                                            type="text"
                                            name="checkoutDate"
                                            disabled={true}
                                            value={this.state.requisition.checkoutDate || ''}
                                        />
                                    </AvGroup>
                                </Col>
                            }
                            <Col md={isDeliveryOrReturn ? '12' : '6'}>
                                <AvGroup>
                                    <Label for="description">
                                        <Translate contentKey="purchaseOrderItem.itemName">Description</Translate>
                                    </Label>
                                    <AvField
                                        type="text"
                                        name="description"
                                        disabled={!this.isEditable()}
                                        value={this.state.requisition.description || ''}
                                        onChange={this.__handleChange}
                                    />
                                </AvGroup>
                            </Col>
                        </Row>
                    </Fieldset>

                    <Fieldset legend="Items">
                        {this.areItemsEditable() &&
                            <div style={{marginLeft: 'auto', display: 'flex', justifyContent: 'flex-end', marginBottom: '8px'}}>
                                <Button
                                    style={{
                                        height: '30px',
                                        width: '30px',
                                        padding: 0,
                                        border: 'none',
                                        boxShadow: 'none',
                                        background: 'transparent'
                                    }}
                                    onClick={this.addNewItem}
                                >
                                    <i className="pi pi-plus" style={{fontSize: '30px', color: '#1982D9'}}/>
                                </Button>
                            </div>
                        }

                        <Dialog
                            visible={this.state.displayDialog}
                            onHide={this.closeItemDialog}
                            className="full-screen-dialog"
                            appendTo={document.body}
                            modal={true}
                            draggable={false}
                            resizable={false}
                        >
                            <PurchaseRequisitionItemMobileSave
                                ref={(elem) => this.refModelSave = elem}
                                readOnly={!this.areItemsEditable()}
                                deliveryMode={isDelivery}
                                returnMode={isReturn}
                                showCostAlternatives={false}
                                documentSupplierId={isDelivery ? this.state.requisition.supplierId : null}
                                documentSupplierName={isDelivery ? this.state.requisition.supplierName : null}
                                documentSupplierBssId={isDelivery ? this.state.requisition.supplierBssId : null}
                                saveItem={this.saveItem}
                                saveItemAndNext={this.saveItemAndNext}
                                deleteItem={this.deleteItem}
                                closeItemDialog={this.closeItemDialog}
                            />
                        </Dialog>

                        <PurchaseRequisitionItemDataTable
                            data={items}
                            selectionMode="single"
                            paginator={true}
                            rows={50}
                            onDataSelect={this.onDataSelect}
                            fields={this.getItemListFields()}
                            highlightCheaperCost={false}
                            rowClassName={this.getItemListRowClassName}
                        />
                    </Fieldset>

                    {this.renderButtons()}
                </AvForm>
                {this.state.loading && <Loading/>}
            </div>
        );
    }

    pushDialogHistory = () => {
        if (!this.dialogHistoryPushed) {
            window.history.pushState({dialog: true}, document.title, window.location.href);
            this.dialogHistoryPushed = true;
        }
    };

    popDialogHistory = () => {
        if (this.dialogHistoryPushed) {
            this.ignoreNextPopState = true;
            window.history.back();
            this.dialogHistoryPushed = false;
        }
    };

    handlePopState() {
        if (this.ignoreNextPopState) {
            this.ignoreNextPopState = false;
            return;
        }
        if (this.state.displaySupplierFilterDialog) {
            this.setState({displaySupplierFilterDialog: false}, () => {
                this.dialogHistoryPushed = false;
                window.history.pushState(null, document.title, window.location.href);
            });
            return;
        }
        if (this.state.displayDialog) {
            this.setState({displayDialog: false}, () => {
                this.dialogHistoryPushed = false;
                window.history.pushState(null, document.title, window.location.href);
            });
        }
    }
}
